import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`
const baseUrl2 = `${process.env.REACT_APP_BACKEND_HOST}/v2/admin`

const smsSend = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/send/sms`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

const kakaoForFriend = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/send/kakao-friend/free`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

const kakaoForDepositCancel = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/crm/send/deposit-cancel`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

const kakaoForCancelRequestRefusal = async (param, userId) => {
  const res = await axios.post(
    `${baseUrl}/kakao/friend/cancelRequestRefusal`,
    param,
    {
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

const kakaoForDelivery = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/crm/send/delivery`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

const kakaoForCancelRequestConfirm = async (param, userId) => {
  const res = await axios.post(
    `${baseUrl}/kakao/friend/cancelRequestApproval`,
    param,
    {
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

// 반품 승인 crm
const kakaoForRefundRequestConfirm = async (param, userId) => {
  const res = await axios.post(
    `${baseUrl}/kakao/friend/refundRequestApproval`,
    param,
    {
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

// 반품 거부 crm
const kakaoForRefundRequestRefusal = async (param, userId) => {
  const res = await axios.post(
    `${baseUrl}/kakao/friend/refundRequestRefusal`,
    param,
    {
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

/**
 * 선물하기 안내 CRM 수기 재발송
 * @param param
 * @param param.orderIdList 주문 아이디(userOrder)의 목록
 * @param param.created_by 사용자 아이디
 * @returns {Promise<*>}
 * orderDetailDTOList: 주문별 재발송 결과 목록
 * order_id, memeo(실패사유)
 * total_cnt
 * 1) 405: 재발송처리를 위한 param 데이터 부족
 * 2) 999: Plutus SuperAdmin권한을 가진 계정이 아님
 */
const postGiftCrmReSend = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/crm/re-send/gift`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

const sendAppPush = async (param) => {
  const res = await axios.post(`${baseUrl}/push/register/byUser`, param)
  return res
}

// 앱푸시 관리

/**
 * 회원 앱푸시 발송 (250714-chm)
 * @param {Object} param
 * @param {string} param.userSegment - 필수 발송 대상 세그먼트 (UserSegment enum 값)
 * @param {number[]} param.selectedUserIds - SELECTED_USERS 세그먼트일 때만 사용되는 회원 ID 배열 다른 타입일 땐 null
 * @param {number} param.pushType - 필수 푸시 타입
 * @param {string} param.title - 필수 푸시 제목
 * @param {string} param.body - 필수 푸시 내용
 * @param {string} [param.url] - 선택적 URL
 * @param {string} [param.imageUrl] - 선택적 이미지 URL
 * @param {string} [param.reservationTime] - 예약 발송 시간 (ISO 문자열)
 */
const sendAppPushToUser = async (param, userId) => {
  try {
    const res = await axios.post(`${baseUrl2}/push/send/app-push`, param)
    return res
  } catch (error) {
    console.error('sendAppPushToUser error:', error.response?.data || error)
    throw error
  }
}

// 앱푸시 템플릿 리스트 조회
const getAppPushTemplates = async ({
  page = 0,
  size = 10,
  sort = 'createdAt,desc',
} = {}) => {
  try {
    const res = await axios.get(`${baseUrl2}/push-templates`, {
      params: {
        page,
        size,
        sort,
      },
    })
    return res // 또는 전체 응답 res 필요하면 res 그대로
  } catch (error) {
    console.error('getAppPushTemplates error:', error.response?.data || error)
    throw error
  }
}

const getAppPushTemplateDetail = async (templateId) => {
  try {
    const res = await axios.get(`${baseUrl2}/push-templates/${templateId}`)
    return res
  } catch (error) {
    console.error(
      'getAppPushTemplateDetail error:',
      error.response?.data || error,
    )
    throw error
  }
}

const createAppPushTemplate = async (param) => {
  try {
    const res = await axios.post(`${baseUrl2}/push-templates`, param)
    return res
  } catch (error) {
    console.error('createAppPushTemplate error:', error.response?.data || error)
    throw error
  }
}

const deleteAppPushTemplate = async (templateId) => {
  try {
    const res = await axios.delete(
      `${baseUrl2}/push-templates/${templateId}/delete`,
    )
    return res
  } catch (error) {
    console.error('deleteAppPushTemplate error:', error.response?.data || error)
    throw error
  }
}

const updateAppPushTemplate = async (templateId, param) => {
  try {
    const res = await axios.post(
      `${baseUrl2}/push-templates/${templateId}/update`,
      param,
    )
    return res
  } catch (error) {
    console.error('updateAppPushTemplate error:', error.response?.data || error)
    throw error
  }
}

/**
 * 특정 유저 세그먼트 포인트 발급 및 카카오 알림톡 발송
 * @param {*} param
 * @returns
 */
const pointWithKakaoAlert = async (param) => {
  try {
    const res = await axios.post(`${baseUrl2}/push/points`, param)
    return res
  } catch (error) {
    console.error('pointWithKakaoAlert error:', error.response?.data || error)
    throw error
  }
}

/**
 * 특정 유저 세그먼트 쿠폰 발급 및 카카오 알림톡 발송
 */
const couponWithKakaoAlert = async (param) => {
  try {
    const res = await axios.post(`${baseUrl2}/push/coupons`, param)
    return res
  } catch (error) {
    console.error('couponWithKakaoAlert error:', error.response?.data || error)
    throw error
  }
}

const getPushHistoryList = async ({
  page = 0,
  size = 10,
  sort = 'createdAt,desc',
} = {}) => {
  try {
    const res = await axios.get(`${baseUrl2}/push/alimtalks`, {
      params: { page, size, sort },
    })
    return res
  } catch (error) {
    console.error('getPushHistoryList error:', error.response?.data || error)
    throw error
  }
}

const getPushHistoryDetail = async (
  campaignId,
  { page = 0, size = 10, sort = 'createdAt,desc' } = {},
) => {
  try {
    const res = await axios.get(`${baseUrl2}/push/alimtalks/${campaignId}`, {
      params: {
        page,
        size,
        sort,
      },
    })
    return res
  } catch (error) {
    console.error('getPushHistoryDetail error:', error.response?.data || error)
    throw error
  }
}

const pushApi = {
  smsSend,
  kakaoForFriend,
  kakaoForDepositCancel,
  kakaoForCancelRequestRefusal,
  kakaoForDelivery,
  postGiftCrmReSend,
  sendAppPush,
  kakaoForCancelRequestConfirm,
  kakaoForRefundRequestConfirm,
  kakaoForRefundRequestRefusal,
  sendAppPushToUser,
  getAppPushTemplates,
  getAppPushTemplateDetail,
  createAppPushTemplate,
  deleteAppPushTemplate,
  updateAppPushTemplate,
  pointWithKakaoAlert,
  couponWithKakaoAlert,
  getPushHistoryList,
  getPushHistoryDetail,
}

export default pushApi
